import messages from "messages";
import { Button } from "react-bootstrap";
// styles
import styles from "./AvailableTimePeriodsViewer.module.scss";
// components
import Schedule from "./components/schedule/Schedule";
import { AmplitudePageName, track } from "utils/amplitude";
import getClasses from "utils/getClasses";

const ID = "available-time-periods";
type Props = {
  activeIndex: number | null;
  timezone: TimeZone;
  value: ParsedAvailableTimePeriod[];
  onCopy: (index: number) => void;
  onCreate: () => void;
  onDelete: (index: number) => void;
  onSelect: (arg: number) => void;
  validities?: (boolean | undefined)[];
  analyticsPageName: AmplitudePageName;
  analyticsComponentName: string;
};

/**
 * renders UI to view all schedules / available time periods
 */
const AvailableTimePeriodsViewer = ({
  activeIndex,
  timezone,
  value,
  onCopy,
  onCreate,
  onDelete,
  onSelect,
  validities,
  analyticsPageName,
  analyticsComponentName,
}: Props) => (
  <div className={styles["available-time-periods-viewer"]}>
    <div className={styles["available-time-periods-viewer__header"]}>
      <label id={ID} className={styles["available-time-periods-viewer__label"]}>
        {messages.mySchedule}
      </label>
      <Button
        type={"button"}
        variant={"link"}
        className={getClasses("p-0", styles["add-new-button"])}
        onClick={() => {
          track(
            analyticsPageName,
            [analyticsComponentName, "create-new-button"],
            "click",
          );
          onCreate();
        }}
      >
        {messages.addNew}
      </Button>
    </div>
    <div className={styles["available-time-periods-viewer__body"]}>
      {!value.length ? (
        <div className={styles["available-time-periods-viewer__no-data"]}>
          {messages.noSchedule}
        </div>
      ) : (
        <div
          aria-labelledby={ID}
          className={styles["available-time-periods-viewer__list"]}
        >
          {value.map((el, i) => (
            <Schedule
              className={styles["available-time-periods-viewer__list-item"]}
              active={i === activeIndex}
              key={i}
              order={i + 1}
              timezone={timezone}
              value={el}
              invalid={validities?.[i] === false}
              onClick={() => {
                track(
                  analyticsPageName,
                  [analyticsComponentName, "schedule"],
                  "click",
                );
                onSelect(i);
              }}
              onCopy={() => {
                track(
                  analyticsPageName,
                  [
                    analyticsComponentName,
                    "duplicate-schedule-dropdown-option",
                  ],
                  "click",
                );
                onCopy(i);
              }}
              onDelete={() => {
                track(
                  analyticsPageName,
                  [analyticsComponentName, "delete-schedule-dropdown-option"],
                  "click",
                );
                onDelete(i);
              }}
            />
          ))}
        </div>
      )}
    </div>
  </div>
);

export default AvailableTimePeriodsViewer;
